import React from "react";
import StatementPdf from "../statement-component/StatementPdf";
import {
  queryStatementList,
  showStatementPdf,
  generateStatementPdf,
} from "./model";

const OfflineStatementPdf = ({ path, redirectFn }) => {
  return (
    <StatementPdf
      path={path}
      redirectFn={redirectFn}
      queryStatementList={queryStatementList}
      showStatementPdf={showStatementPdf}
      generateStatementPdf={generateStatementPdf}
    />
  );
};

export default React.memo(OfflineStatementPdf);
